const words = ["Tropical", "Luxury", "Inclusive", "Boutique", "Sun-Soaked", "Effortless"];

export default function Marquee() {
  const row = [...words, ...words];
  return (
    <div data-testid="editorial-marquee" className="bg-sand-2 border-y border-emerald/10 py-6 overflow-hidden">
      <div className="marquee-track">
        {row.map((w, i) => (
          <span key={i} className="font-display text-4xl md:text-6xl text-emerald/90 tracking-tight mx-8 flex items-center gap-8">
            {w}
            <span className="text-sunset text-2xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
